<template>
  <footer>
    <p class="text-muted text-center"><strong>&copy; 2018 SAED</strong>- Licencias</p>
  </footer>
</template>

<script>
name: 'Foot'
</script>
<style>

footer{
  width: 100%;
  bottom: 0;
  position: relative;

}
footer p{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/template/Foot.vue